import { NgModule } from '@angular/core';
import { ApxDropdownComponent } from './dropdown.component';
import { ApxDropdownOptionItemComponent } from './dropdown-option-item/dropdown-option-item.component';
import { ApxDropdownOptionComponent } from './dropdown-option/dropdown-option.component';

@NgModule({
    imports: [ApxDropdownComponent, ApxDropdownOptionItemComponent, ApxDropdownOptionComponent],
    exports: [ApxDropdownComponent, ApxDropdownOptionComponent]
})
export class ApxDropdownModule {}

// Re-export components for barrel exports
export { ApxDropdownComponent } from './dropdown.component';
export { ApxDropdownOptionItemComponent } from './dropdown-option-item/dropdown-option-item.component';
export { ApxDropdownOptionComponent } from './dropdown-option/dropdown-option.component';
